module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hans/2-bb146dab436a2a6150b3e6a1d1869706.jpg";